// Requiry Flickity
var Flickity = require('flickity');
var Flickity_nav_for = require('flickity-as-nav-for');